import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const calorSignupManagementRoute: RouteConfig<'with-page'> = {
    name: 'Signups',
    path: '/calor/signups',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin', 'calorSignupsEmployee'],
}